import authCookieManager from '@App/cookies/auth_cookie_manager'
import { useAppDispatch, useAppSelector } from '@App/hooks'
import { makeCancelOrderRequest } from '@App/redux/slices/sockets/FrontServiceConnectionSlice'
import { clearEditOrder } from '@App/redux/slices/trade/trades/OrdersSlice'
import { Order } from '@App/redux/slices/trade/trades/types'
import { Button } from '@App/ui/crypto_exchange/desktop/components/controls/Button'
import s from './styles.module.scss'
import { currentUser } from '@Redux/slices/user/selectors'

export const CancelOrderButton = ({ order }: { order: Order }) => {
  const dispatch = useAppDispatch()
  const user = useAppSelector(currentUser)

  const onCancelOrder = () => {
    dispatch(
      makeCancelOrderRequest({
        market_id: order.market.id,
        token: authCookieManager.getAccessToken() || '',
        user_id: user.user_id,
        amount: order.quantity,
        action: order.action_type,
        wallet_id: order.wallet_id,
        rate: order.open_rate,
        trade_id: order.id,
      }),
    )

    // dispatch(fetchOrders())
    dispatch(clearEditOrder())
  }

  return (
    <Button onClick={onCancelOrder} variant="ghost" className={s.button}>
      Cancel order
    </Button>
  )
}
